import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import {
  RANK_TAB_TYPE,
  TIME_TAB_CHANGE_TYPE,
  INDEX_RANK_ITEM_LIST_TYPE,
} from '.'
import { creatorsTimeTabsData } from './useCreators'

import {
  GET_AI_SAME_STYLE_RANK,
  GET_AI_PICTURE_COUNT_RANK,
  GET_AI_FANS_COUNT_RANK,
} from '~/graphqls/gqls'

import {
  getAiSameStyleRank,
  getAiSameStyleRankVariables,
  getAiPictureCountRank,
  getAiPictureCountRankVariables,
  getAiFansCountRank,
  getAiFansCountRankVariables,
  getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
  QueryDateEnum,
} from '~/graphqls/types'

import { getGraphData } from '~/utils'

/** ai创作者：时间切换 */
export const aiCreatorsTimeTabsData = [
  { key: QueryDateEnum.SEVEN_DAYS, name: '7日' },
  { key: QueryDateEnum.THIRTY_DAYS, name: '30日' },
]

/** AI创作分类 */
export enum AI_CREATORS_TAB_TYPE {
  SAME_STYlE = 'SAME_STYlE',
  PICTURE_COUNT = 'PICTURE_COUNT',
  FANS_COUNT = 'FANS_COUNT',
}

/** AI创作榜tab分类 */
export const aiCreatorsTabList = [
  { key: AI_CREATORS_TAB_TYPE.SAME_STYlE, name: '同款榜' },
  { key: AI_CREATORS_TAB_TYPE.PICTURE_COUNT, name: '作画榜' },
  { key: AI_CREATORS_TAB_TYPE.FANS_COUNT, name: '粉丝榜' },
]

export const useAiCreators = () => {
  const getAiSameRankList = useImperativeQuery<
    getAiSameStyleRank,
    getAiSameStyleRankVariables
  >(GET_AI_SAME_STYLE_RANK)

  const getAiPictureRankList = useImperativeQuery<
    getAiPictureCountRank,
    getAiPictureCountRankVariables
  >(GET_AI_PICTURE_COUNT_RANK)

  const getAiFansRankList = useImperativeQuery<
    getAiFansCountRank,
    getAiFansCountRankVariables
  >(GET_AI_FANS_COUNT_RANK)

  /** 单tab数据切换 */
  const fetchSingle = async (
    params: getAiSameStyleRankVariables,
    type: string
  ) => {
    let res: any = {}
    if (type === AI_CREATORS_TAB_TYPE.SAME_STYlE) {
      res = await getAiSameRankList(params)
    } else if (type === AI_CREATORS_TAB_TYPE.PICTURE_COUNT) {
      res = await getAiPictureRankList(params)
    } else {
      res = await getAiFansRankList(params)
    }
    return getGraphData<getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node>(
      res.data?.copyrightStatisticsModule?.aiCreatorsList?.edges || []
    )
  }

  /** 获取所有数据 */
  const fetchAll = async (params: getAiSameStyleRankVariables) => {
    const list = await Promise.all([
      getAiSameRankList(params),
      getAiPictureRankList(params),
      getAiFansRankList({
        ...params,
        // 默认是全部时间
        date: QueryDateEnum.ALL_TIME,
      }),
    ])

    return list?.map((res: any, index: number) => {
      return {
        type: aiCreatorsTabList[index].key,
        name: aiCreatorsTabList[index].name,
        data: getGraphData<getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node>(
          res.data?.copyrightStatisticsModule?.aiCreatorsList?.edges || []
        ),
      }
    })
  }

  /** 首页数据卡片样式 */
  const formatIndexList = (
    list: getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node[],
    type: string,
    name: string,
    onTimeChange?: TIME_TAB_CHANGE_TYPE
  ): INDEX_RANK_ITEM_LIST_TYPE<getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node> => {
    return {
      parentType: RANK_TAB_TYPE.AI_CREATORS,
      type,
      name,
      data: list,
      timeTabsList:
        type !== AI_CREATORS_TAB_TYPE.FANS_COUNT ? aiCreatorsTimeTabsData : [],
      onTimeChange,
    }
  }

  /** 处理首页的展示逻辑 */
  const handleIndexAll = async (
    params: getAiSameStyleRankVariables,
    onTimeChange?: TIME_TAB_CHANGE_TYPE
  ) => {
    const allList = await fetchAll(params)
    return allList?.map(single => {
      return formatIndexList(
        single.data,
        single.type,
        single.name,
        onTimeChange
      )
    })
  }

  return {
    // AI创作榜
    /** 同款榜 */
    getAiSameRankList,
    /** 作画榜 */
    getAiPictureRankList,
    /** 粉丝榜 */
    getAiFansRankList,

    // 数据操作
    fetchAiCreatorsSingle: fetchSingle,
    fetchAiCreatorsAll: fetchAll,
    formatAiCreatorsIndexList: formatIndexList,
    handleAiCreatorsIndexAll: handleIndexAll,
  }
}
